(() => {
  const syncPurchaseCards = (root = document) => {
    root.querySelectorAll('.nw-purchase-options').forEach((group) => {
      const radios = group.querySelectorAll('.nw-purchase-radio');
      radios.forEach((radio) => {
        const card = radio.closest('.nw-purchase-card');
        if (card) card.classList.toggle('is-selected', radio.checked);
      });
    });
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.nw-purchase-radio')) return;
    const group = event.target.closest('.nw-purchase-options');
    if (group) syncPurchaseCards(group);
  });

  document.addEventListener('DOMContentLoaded', () => syncPurchaseCards());
  document.addEventListener('shopify:section:load', (event) => syncPurchaseCards(event.target));
})();
